// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateArgentineDocument } from './argentine-document';
import { validateArgentinePhoneNumber } from './argentine-phone-number';
import { validateArgentineZipcode } from './argentine-zipcode';
import { validateArgentineState } from './argentine-state';
import { validateArgentineCity } from './argentine-city';
import { validateArgentineAddress } from './argentine-address';
import { validateArgentineStreetNumber } from './argentine-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { validateArgentineDocumentType } from  './argentine-document-type';
import { validateArgentineCbu } from  './argentine-cbu';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);

  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = [];
  if (incomingPayment.status === 'OP') {
    optionalFields = getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec);
  }

  switch (userInputName) {
    case 'argentineDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_argentine_document') && validateArgentineDocument(userInputValue, userInputValues['argentineDocumentType']);
      }
      return null;


    case 'argentinePhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_argentine_phone_number') && validateArgentinePhoneNumber(userInputValue);
      }
      return null;


    case 'argentineZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_argentine_zipcode') && validateArgentineZipcode(userInputValue);
      }
      return null;


    case 'argentineState':
      if (!hasOptionalField(optionalFields, 'state')) {
        return onlyWhen('field_argentine_state') && validateArgentineState(userInputValue);
      }
      return null;


    case 'argentineCity':
      if (!hasOptionalField(optionalFields, 'city')) {
        return onlyWhen('field_argentine_city') && validateArgentineCity(userInputValue);
      }
      return null;


    case 'argentineAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_argentine_address') && validateArgentineAddress(userInputValue);
      }
      return null;


    case 'argentineStreetNumber':
      if (!hasOptionalField(optionalFields, 'street_number')) {
        return onlyWhen('field_argentine_street_number') && validateArgentineStreetNumber(userInputValue);
      }
      return null;


    case 'argentineDocumentType':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_argentine_document_type') && validateArgentineDocumentType(userInputValue);
      }
      return null;


    case 'argentineCbu':
      return onlyWhen('field_argentine_cbu') && validateArgentineCbu(userInputValue);

    default:
      return VALID;
  }
}
